<button mat-button [matMenuTriggerFor]="themeMenu">Theme</button>
<mat-menu #themeMenu="matMenu">
  <button mat-menu-item (click)="setTheme('theme-dark')">Dark</button>
  <button mat-menu-item (click)="setTheme('theme-gunmetal')">Gun Metal</button>
  <button mat-menu-item (click)="setTheme('theme-indigo')">Indigo</button>
  <button mat-menu-item (click)="setTheme('theme-light')">Light</button>
  <button mat-menu-item (click)="setTheme('theme-mortal-kombat')">Mortal Kombat</button>
  <button mat-menu-item (click)="setTheme('theme-sand')">Sand</button>  
  <button mat-menu-item (click)="setTheme('theme-sapphire')">Sapphire</button>
</mat-menu>